module.exports = __webpack_public_path__ + "static/img/station-icon-active.0ea89cd3.svg";